import React, { useRef, useState } from 'react';
import styles from './VotingSession.module.css';
import classNames from 'classnames';

interface InlineEditableProps {
  value: string;
  onChange: (value?: string) => void;
}

const InlineEditable: React.FC<InlineEditableProps> = ({ value, onChange }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={classNames(styles.inlineEditable, {
        [styles.inlineEditableEditing]: editing,
      })}
    >
      <div hidden={editing}>{value}</div>
      <span hidden={!editing}>
        <input
          className={classNames('unstyled-input')}
          type='text'
          value={value}
          ref={inputRef}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              inputRef.current?.blur();
            }
          }}
          onBlur={() => setEditing(false)}
          onChange={() => onChange(inputRef.current?.value)}
        />
      </span>
      <aha-button kind='plain' class={styles.inlineEditableEditButton}>
        <i
          className='fa-regular fa-pen color-secondary'
          onClick={() => {
            setEditing(true);
            setTimeout(() => inputRef.current?.select(), 10);
          }}
        />
      </aha-button>
    </div>
  );
};

export default InlineEditable;
